var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-switch", {
        staticStyle: { display: "block", width: "10rem", margin: "0.5rem 0" },
        attrs: {
          "active-color": "#13ce66",
          "inactive-color": "#13ce66",
          "active-text": "占比",
          "inactive-text": "销量"
        },
        model: {
          value: _vm.switchValue,
          callback: function($$v) {
            _vm.switchValue = $$v
          },
          expression: "switchValue"
        }
      }),
      _c(
        "el-table",
        {
          ref: "tableStationPayDistribution" + _vm.sheetType,
          attrs: {
            data: _vm.renderData,
            "highlight-current-row": "",
            height: "700",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "cell-style": _vm.cellStyle,
            "header-cell-style": { "text-align": "center" },
            border: ""
          },
          on: { "filter-change": _vm.filterChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              label: _vm.selectedArea,
              align: "center",
              "column-key": "area",
              filters: _vm.filterMapping,
              "filter-multiple": false,
              "filter-placement": "right",
              "filter-method": _vm.filterHandler
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.sellerName(scope.row.stationId)) + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "总计",
              width: "100px",
              align: "center",
              prop: "totalNums"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          !_vm.switchValue
                            ? scope.row.totalNums
                            : _vm.percentShow(
                                scope.row.totalNums,
                                scope.row.totalNums
                              )
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "el-table-column",
            { attrs: { label: "公司会员", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "储值卡",
                  width: "100px",
                  align: "center",
                  prop: "svcNums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.svcNums
                                : _vm.percentShow(
                                    scope.row.svcNums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "点付",
                  width: "100px",
                  align: "center",
                  prop: "userNums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.userNums
                                : _vm.percentShow(
                                    scope.row.userNums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { label: "平台", align: "center" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "平台合计",
                  width: "100px",
                  align: "center",
                  prop: "platTotalNums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.platTotalNums
                                : _vm.percentShow(
                                    scope.row.platTotalNums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "滴滴",
                  width: "100px",
                  align: "center",
                  prop: "plat2001Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2001Nums
                                : _vm.percentShow(
                                    scope.row.plat2001Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "小象",
                  width: "100px",
                  align: "center",
                  prop: "plat2005Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2005Nums
                                : _vm.percentShow(
                                    scope.row.plat2005Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "团油",
                  width: "100px",
                  align: "center",
                  prop: "plat2004Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2004Nums
                                : _vm.percentShow(
                                    scope.row.plat2004Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "货车帮",
                  width: "100px",
                  align: "center",
                  prop: "plat2002Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2002Nums
                                : _vm.percentShow(
                                    scope.row.plat2002Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "易加油",
                  width: "100px",
                  align: "center",
                  prop: "plat2003Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2003Nums
                                : _vm.percentShow(
                                    scope.row.plat2003Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "货拉拉",
                  width: "100px",
                  align: "center",
                  prop: "plat2010Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2010Nums
                                : _vm.percentShow(
                                    scope.row.plat2010Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "佰思达",
                  width: "100px",
                  align: "center",
                  prop: "plat2011Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2011Nums
                                : _vm.percentShow(
                                    scope.row.plat2011Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "爱车平台",
                  width: "100px",
                  align: "center",
                  prop: "plat2012Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2012Nums
                                : _vm.percentShow(
                                    scope.row.plat2012Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "团油车队",
                  width: "100px",
                  align: "center",
                  prop: "plat2013Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2013Nums
                                : _vm.percentShow(
                                    scope.row.plat2013Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "鲸车惠",
                  width: "100px",
                  align: "center",
                  prop: "plat2014Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2014Nums
                                : _vm.percentShow(
                                    scope.row.plat2014Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "途虎",
                  width: "100px",
                  align: "center",
                  prop: "plat2009Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2009Nums
                                : _vm.percentShow(
                                    scope.row.plat2009Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "喂车车",
                  width: "100px",
                  align: "center",
                  prop: "plat2008Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2008Nums
                                : _vm.percentShow(
                                    scope.row.plat2008Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "嗨卡",
                  width: "100px",
                  align: "center",
                  prop: "plat2007Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat2007Nums
                                : _vm.percentShow(
                                    scope.row.plat2007Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "刷脸付",
                  width: "100px",
                  align: "center",
                  prop: "plat1008Nums"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.switchValue
                                ? scope.row.plat1008Nums
                                : _vm.percentShow(
                                    scope.row.plat1008Nums,
                                    scope.row.totalNums
                                  )
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("el-table-column", {
            attrs: {
              label: "其他",
              width: "100px",
              align: "center",
              prop: "otherNums"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          !_vm.switchValue
                            ? scope.row.otherNums
                            : _vm.percentShow(
                                scope.row.otherNums,
                                scope.row.totalNums
                              )
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }